import React from "react";
import { MdAdd, MdDelete, MdDownload } from "react-icons/md";
import { useIntl } from "react-intl";

import { operationGetCarLayers, operationGetGlebas } from "~/api";
import { formatNumber } from "~/utils/format";

export const fetchCarStartData = async ({
  formatMessage,
  operationId,
  setResponse
}) => {
  try {
    const response = await operationGetCarLayers(operationId, 1);
    const carLayersResult = response.data.result;

    const responseGleba = await operationGetGlebas(operationId);
    const glebasResult = responseGleba.data.result;

    const apiCarList = carLayersResult.map(car => {
      const glebasList = glebasResult.filter(
        gleba => gleba.b3_car_id === car.B3Car.id
      );

      return {
        ...car,
        Gleba: glebasList
      };
    });

    setResponse({ result: apiCarList });
  } catch (err) {
    setResponse({
      error: err?.response?.data?.message || formatMessage({ id: "erro-api" })
    });
  }
};

const ADD_AREA_TO_CAR_MODAL = "ADD_AREA_TO_CAR_MODAL";

export const RenderCarStart = ({
  loading,
  itemsList,
  isAddingArea,
  selectedGlebaId,
  setOpenModal,
  selectedCar,
  setSelectedCarIndex,
  setIsAddingArea,
  setSelectedGlebaId,
  handleDownloadArea,
  handleDeleteArea
}) => {
  const { formatMessage } = useIntl();

  return (
    <>
      {!loading && (
        <>
           {!itemsList.length ? (
            <div className="is-12">
              <h4>{formatMessage({ id: "nenhum-car-encontrado" })}</h4>
            </div>
          ):(
            <>
              <div className="car-list">
                {!loading &&
                  itemsList.map((car, carIndex) => (
                    <div
                      key={carIndex}
                      className={`car-item 
                                ${
                                  selectedCar?.B3CarsB3Proposta.id ===
                                  car.B3CarsB3Proposta.id
                                    ? "is-expanded"
                                    : ""
                                }`}
                    >
                      <div
                        key={carIndex}
                        className={`car-item-wrapper`}
                        onClick={() => {
                          setSelectedCarIndex(carIndex);
                          setIsAddingArea(false);
                          setSelectedGlebaId(null);
                        }}
                      >
                        <div className={`car-item-info`}>
                          <p>
                            CAR {carIndex + 1} - {formatMessage({ id: "area" })}{" "}
                            {formatNumber(car.B3Car.B3Area[0].area_ha)} ha
                          </p>

                          <span>
                            {car.B3Car.numero ||
                              formatMessage({ id: "sem-titulo" })}
                          </span>
                        </div>
                      </div>

                      {selectedCar?.B3CarsB3Proposta.id ===
                        car.B3CarsB3Proposta.id && (
                        <div className="car-item-expanded">
                          {car.Gleba.map((gleba, glebaIndex) => (
                            <span
                              className={`car-item-area ${
                                selectedGlebaId === gleba.id
                                  ? "is-area-selected"
                                  : ""
                              }`}
                              key={glebaIndex}
                              onClick={() => setSelectedGlebaId(gleba.id)}
                            >
                              {formatMessage({ id: "gleba" })} {glebaIndex + 1}{" "}
                              - {formatMessage({ id: "area" })}{" "}
                              {new Intl.NumberFormat("pt-BR", {
                                maximumFractionDigits: 2
                              }).format(gleba.area_ha)}{" "}
                              ha
                              <div className="car-itens">
                                <div className="car-item-download">
                                  <MdDownload
                                    className="download"
                                    size={16}
                                    onClick={() => handleDownloadArea(gleba.id)}
                                  />
                                </div>
                                <div className="car-item-delete">
                                  <MdDelete
                                    className="trash"
                                    size={16}
                                    onClick={() => handleDeleteArea(gleba.id)}
                                  />
                                </div>
                              </div>
                            </span>
                          ))}

                          {isAddingArea ? (
                            <span
                              className="cancel-draw-area-button"
                              onClick={() => setIsAddingArea(false)}
                            >
                              {formatMessage({ id: "cancelar-desenho" })}
                            </span>
                          ) : (
                            <span
                              className="add-area-button"
                              onClick={() =>
                                setOpenModal(ADD_AREA_TO_CAR_MODAL)
                              }
                            >
                              <MdAdd size={20} />
                              {formatMessage({ id: "adicionar-gleba" })}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};
